import { noop } from 'lodash';
import React, { ReactNode, createContext, useState } from 'react';

import { AppContainer } from '@components/AppContainer';
import { Loading } from '@components/Loading';
import { StartLoader } from '@components/StartLoader';
import { paths } from '@constants/paths';
import { RequestState } from '@src/types/index';

type LoaderContext = {
  requestStatus: RequestState;
  setCurrentPathname: (pathname: string) => void;
  setRequestState: (state: RequestState) => void;
};

type LoaderContextProviderProps = {
  children: ReactNode;
};

const initialContext: LoaderContext = {
  requestStatus: RequestState.loading,
  setCurrentPathname: noop,
  setRequestState: noop,
};

const LoaderContext = createContext<LoaderContext>(initialContext);

const getLoaderMessage = (pathname: string) => {
  let message = 'Just a moment while we can check what we can offer you...';

  if (
    pathname === paths.energy ||
    pathname === paths.broadband ||
    pathname === paths.mobile
  ) {
    message = 'Processing your data. This may take a few moments...';
  }

  if (pathname === paths.deposit) {
    message = 'Processing your deposit. This may take a few moments...';
  }

  if (pathname === paths.thankYou) {
    message = 'Processing your order. This may take a few moments...';
  }

  return message;
};

const LoaderProvider: React.FC<LoaderContextProviderProps> = ({ children }) => {
  const [requestStatus, setRequestStatus] = useState<RequestState>(
    RequestState.loading
  );
  const [pathname, setPathname] = useState('');

  const contextValue: LoaderContext = {
    requestStatus,
    setCurrentPathname: setPathname,
    setRequestState: setRequestStatus,
  };

  return (
    <LoaderContext value={contextValue}>
      <AppContainer>
        {children}
        {requestStatus === RequestState.loading &&
          (pathname === paths.address ? (
            <StartLoader />
          ) : (
            <Loading
              className="global-loading"
              loadingText={getLoaderMessage(pathname)}
            />
          ))}
      </AppContainer>
    </LoaderContext>
  );
};

export { LoaderContext, LoaderProvider };
